import React, { useEffect, useState } from "react";
import { CloudLightning, DownloadSimple } from "@phosphor-icons/react";
import { api } from "../../lib/api";

const CSV_URL = `${process.env.REACT_APP_BACKEND_URL}/api/lightning/history.csv`;

export default function LightningHistoryCard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/lightning/history").then(({ data: d }) => setData(d)).catch(() => {});
  }, []);

  const days = data?.days || [];
  const recent = days.slice(-7).reverse();

  return (
    <div className="bg-tac-surface/40 border border-tac-border rounded-sm p-5 space-y-3" data-testid="admin-lightning-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2">
          <CloudLightning size={18} weight="fill" className="text-[#FFD60A]" />
          <h2 className="font-display font-black uppercase tracking-wider text-sm">Lightning History</h2>
        </div>
        <a
          href={CSV_URL}
          data-testid="admin-lightning-csv-btn"
          className="px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider rounded-sm border bg-tac-bg/85 border-tac-border text-tac-text hover:border-tac-borderBright transition-colors flex items-center gap-1.5"
        >
          <DownloadSimple size={13} weight="bold" /> Download CSV
        </a>
      </div>
      <div className="text-[12px] text-tac-dim">
        Permanent daily strike counts per county (Pacific days), collected from the live
        Blitzortung feed.{" "}
        {days.length > 0 ? (
          <>
            <span className="text-tac-text font-bold">{days.length}</span> day{days.length === 1 ? "" : "s"} recorded
            since <span className="text-tac-text font-bold">{days[0].date}</span> ·{" "}
            <span className="text-tac-text font-bold">{data.total.toLocaleString()}</span> total strikes.
          </>
        ) : (
          "No days recorded yet — summaries begin accumulating within minutes of storms crossing the region."
        )}
      </div>
      {recent.length > 0 && (
        <div className="divide-y divide-tac-border/60 border border-tac-border/60 rounded-sm" data-testid="admin-lightning-days">
          {recent.map((d) => (
            <div key={d.date} className="px-3 py-1.5 flex items-center justify-between text-[12px]">
              <span className="font-mono-tac text-tac-dim">{d.date}</span>
              <span className="text-tac-text font-bold tabular">{d.total.toLocaleString()} strikes</span>
            </div>
          ))}
        </div>
      )}
      <div className="text-[10px] text-tac-faint">
        Lightning data by Blitzortung.org and contributors (CC BY-SA). History before feature
        install is not available.
      </div>
    </div>
  );
}
